<template>
  <v-app>
    <header />

    <nav>
      <app-navbar></app-navbar>
    </nav>
    
    <main :style="user !== null && user !== undefined ? 'padding-top: 48px' : ''">
      <router-view />
    </main>

    <aside v-if="user !== null && user !== undefined">
      <app-floating-buttons v-if="!isMobile">
      </app-floating-buttons>
      <app-timeline-filter></app-timeline-filter>
    </aside>

    <footer>
      <app-bottom-nav v-if="isMobile">
      </app-bottom-nav>
      <app-footer-start v-if="user == null || user == undefined"></app-footer-start>
    </footer>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { debounce } from 'lodash'


import Navbar                 from '@/components/global_comps/Navigation/Navbar.vue'
import BottomNav              from '@/components/global_comps/Navigation/Mobile_BottomNav.vue'
import FloatingButtons        from '@/components/global_comps/Navigation/Desktop_FloatingButtons'
import TimelineFilter         from '@/components/global_comps/Filter/TimelineFilter'
import FooterStart            from '@/components/global_comps/Footer_Start'

export default {
  name: 'App',
  components: {
    'app-navbar': Navbar,
    'app-bottom-nav': BottomNav,
    'app-floating-buttons': FloatingButtons,
    'app-timeline-filter': TimelineFilter,
    'app-footer-start': FooterStart,
   
  },

  data() {
    return {
      
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      breakPointMobile: state => state.breakPointMobile,
      path: state => state.route.path,
      user: state => state.user.user,
      searchActive: state => state.searchActive
    }),
    payloadNav() {
      return {'user': this.user, 'path': this.path}
    },
    resizeDebounce () {
      return debounce(this.handleResize, 500, {'maxWait': 1000})
    }

   
  },
  watch: {
    $route(to, from) {
      if (this.isMobile) {
        this.navElementsMobile(this.payloadNav)
      } else {
        this.navElementsDesktop(this.payloadNav)
      }
    },
    user(value) {
      if (this.isMobile) {
        this.navElementsMobile(this.payloadNav)
      } else {
        this.navElementsDesktop(this.payloadNav)
      }
    },
    
  },
  created() {
    window.addEventListener('resize', this.resizeDebounce)
    this.handleResize()
    // this.$store.dispatch('loadEvents')
    // this.$store.dispatch('loadMoments')
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeDebounce)
  },
  methods: {
    ...mapMutations([
      'navElements',
      'navElementsMobile',
      'navElementsDesktop',
      'setIsMobile'
    ]),

    handleResize() {
      // console.log('resizeNow')
      if (window.innerWidth < this.breakPointMobile) {
        if (this.isMobile !== true) {
          this.setIsMobile(true)
          this.navElementsMobile(this.payloadNav)
        }
      } else {
        if (this.isMobile !== false) {
          this.setIsMobile(false)
          this.navElementsDesktop(this.payloadNav)
        }
      }
    }
  }
}
</script>

<style lang="scss">


html,
body,
main {

  height: 100%;
  // line-height: 1.3;
  // font-family: 'Roboto', sans-serif;
  // font-family: 'Open Sans', sans-serif;
  // font-family: 'Montserrat', sans-serif;
  // font-family: 'Raleway', sans-serif;
  // font-family: 'Muli', sans-serif;
// font-family: 'Work Sans', sans-serif;
// font-family: 'Nunito Sans', sans-serif;
// font-family: 'Varela Round', sans-serif;

  ::-webkit-scrollbar {
    display: none;
    width: 0px;  /* remove scrollbar space */
    background: transparent;  /* optional: just make scrollbar invisible */
  }
  
}

// main {
//   padding-top: 48px;
// }

::-webkit-scrollbar {
    display: none;
    width: 0px;  /* remove scrollbar space */
    background: transparent;  /* optional: just make scrollbar invisible */
  }


.fas, .far, .fab, .fal{
    font-size: 20px;
    vertical-align: baseline;
    // vertical-align: middle;
}


// Chrome Auto-Fill (remove yellow background)
// textarea:-webkit-autofill,
// textarea:-webkit-autofill:hover
// textarea:-webkit-autofill:focus,
// select:-webkit-autofill,
// select:-webkit-autofill:hover,
// select:-webkit-autofill:focus,
// input:-webkit-autofill,
// input:-webkit-autofill:hover,
// input:-webkit-autofill:focus,
// input:-webkit-autofill:active {
//     transition: background-color 9999s ease-in-out 0s;
// }


// Chrome Auto-Fill (remove yellow background)
@-webkit-keyframes autofill {
    to {
        color: #000;
        background: transparent;
        
    }
}
@keyframes autofill {
    to {
        color: #000;
        background: transparent;
    }
}

select,
textarea,
input:-webkit-autofill {
  animation-name: autofill;
    animation-fill-mode: both;
    -webkit-animation-name: autofill;
    -webkit-animation-fill-mode: both;
}


.wevent_icon_wrapper_brand {
  -webkit-filter: drop-shadow(0px 2px 5px rgba(173, 132, 132, 0.55));
  filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.55));
}
.wevent_icon_wrapper_icons {
  -webkit-filter: drop-shadow(0px 2px 5px rgba(173, 132, 132, 0.3));
  filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.3));
}


.pac-container {
  // width: auto !important;
  // width: inherit !important;
  // background-color: rgba(250, 250, 250, 0.8);
  // margin-left: -20px !important;
  margin: 0 !important;
  padding: 0 !important;
  min-width: 120px;
  left: 0;
  right: 0;
  // left: 50% !important;
  // transform: translateX(-50%);
  margin-top: 6px !important;
  padding-top: 3px !important;
  /* background: rgba(255, 255, 255, 0.7); */
  border-radius: 8px;
  // border-top-left-radius: 0;
  // border-top-right-radius: 0;
  border: 0; }

.pac-item {
  
  padding: 3px 20px;
  border: 0; 
  }

/*
.pac-container:after {
  content: "Powered by Google";
  font-size: 10px;
  background-image: none;
}*/
.pac-logo:after {
  margin: 5px;
  text-align: right;
  color: #c3c3c3;
  font-size: 12px;
  content: "Powered by Google";
  background-image: none !important;
  font-family: 'Work Sans', sans-serif;
  font-weight: 400; }


.v-overlay {
  z-index: 6;
}

.roundedcard{
    border-radius:16px !important;
}

.v-dialog {
    border-radius:16px !important;
}

.v-dialog--active {
    border-radius:16px !important;
}




.theme-moment .vdatetime-popup__header,
.theme-moment .vdatetime-calendar__month__day--selected > span > span,
.theme-moment .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #FFCA28;
  border-top-left-radius:16px !important;
  border-top-right-radius:16px !important;
  font-family: 'Nunito Sans', sans-serif;
  height: 56px;
}

.theme-moment .vdatetime-year-picker__item--selected,
.theme-moment .vdatetime-time-picker__item--selected {
  color: #FFCA28;
  // border-radius:16px !important;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 32px;
}


.theme-moment .vdatetime-popup__actions__button {
  color: #78909C;
  // border-radius:16px !important;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
}

.theme-event .vdatetime-popup__header,
.theme-event .vdatetime-calendar__month__day--selected > span > span,
.theme-event .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #EC407A;
  border-top-left-radius:16px !important;
  border-top-right-radius:16px !important;
  font-family: 'Nunito Sans', sans-serif;
  height: 56px;
}

.theme-event .vdatetime-year-picker__item--selected,
.theme-event .vdatetime-time-picker__item--selected {
  color: #EC407A;
  // border-radius:16px !important;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 32px;
}

.theme-event .vdatetime-popup__actions__button {
  color: #78909C;
  // border-radius:16px !important;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
}
.vdatetime-popup {
  max-width: 290px !important;
  border-radius:16px !important;
  z-index: 1000;
  font-family: 'Nunito Sans', sans-serif;
}

.inputdatetimeclass  {
 display: none;
// visibility: hidden;
}

.vdatetime-overlay {
background: rgba(33,33,33,0.5) !important;

}
</style>
